var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreadcrumbHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7143 4.07468C11.8608 3.92823 12.0982 3.92823 12.2447 4.07468L18.7295 10.5595V20.3739C18.7295 20.581 18.5616 20.7489 18.3545 20.7489H16.4795H14.9795V16.6239C14.9795 15.5884 14.14 14.7489 13.1045 14.7489H10.8545C9.81896 14.7489 8.97949 15.5884 8.97949 16.6239V20.7489H8.22949H5.60449C5.39739 20.7489 5.22949 20.581 5.22949 20.3739V10.5595L11.7143 4.07468L11.184 3.54435L11.7143 4.07468ZM3.72949 12.0595L2.75982 13.0292C2.46693 13.3221 1.99206 13.3221 1.69916 13.0292C1.40627 12.7363 1.40627 12.2614 1.69916 11.9685L10.6537 3.01402C11.3859 2.28179 12.5731 2.28179 13.3053 3.01402L22.2598 11.9685C22.5527 12.2614 22.5527 12.7363 22.2598 13.0292C21.9669 13.3221 21.4921 13.3221 21.1992 13.0292L20.2295 12.0595V20.3739C20.2295 21.4094 19.39 22.2489 18.3545 22.2489H16.4795H14.2295H9.72949H8.22949H5.60449C4.56896 22.2489 3.72949 21.4094 3.72949 20.3739V12.0595ZM13.4795 20.7489H10.4795V16.6239C10.4795 16.4168 10.6474 16.2489 10.8545 16.2489H13.1045C13.3116 16.2489 13.4795 16.4168 13.4795 16.6239V20.7489Z",
    fill: "#C3CBD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbHome);
export default __webpack_public_path__ + "static/media/breadcrumb-home.8a1e942474e0223a0c031351271323ff.svg";
export { ForwardRef as ReactComponent };